import { render, staticRenderFns } from "./IncomesExpenses.vue?vue&type=template&id=198118cc&scoped=true&"
import script from "./IncomesExpenses.vue?vue&type=script&lang=js&"
export * from "./IncomesExpenses.vue?vue&type=script&lang=js&"
import style0 from "./IncomesExpenses.vue?vue&type=style&index=0&id=198118cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198118cc",
  null
  
)

export default component.exports